import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { ADMIN_ROUTES } from "@/config/admin-routes";
import { streamerHubSidebarConfig } from "@/config/sidebar-configs";
import { FEATURE_FLAG_KEYS } from "@/features/feature-flags/api/feature-flag-queries";
import { useAutheMeQuery, useGetProfileQuery } from "@/features/auth/api/profile-queries";
import { hasUserFeature, USER_FEATURE_KEYS, type AuthenticatedUserInfo, type ROLES } from "@/features/auth/api/types";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import type { SidebarConfig, SidebarNavGroup } from "@/types/sidebar";
function isVisibleToAccount(roles: readonly ROLES[] | undefined, accountType: string) {
  if (!roles?.length) return true;
  return roles.includes(accountType as ROLES);
}
export function useSidebarNavGroups(config) {
  const $ = _c(19);
  const {
    data: userInfo
  } = useAutheMeQuery(undefined) as {
    data: AuthenticatedUserInfo | undefined;
  };
  const {
    enabled: isNewsEnabled
  } = useFeatureFlag(FEATURE_FLAG_KEYS.NEWS);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      bypassForAdmin: true
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    enabled: isChallengesFeatureEnabled
  } = useFeatureFlag(FEATURE_FLAG_KEYS.CHALLENGES, t0);
  const t1 = userInfo?.features;
  let t2;
  if ($[1] !== t1) {
    t2 = hasUserFeature(t1, USER_FEATURE_KEYS.CHALLENGES_CLIPS);
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const isChallengesClipsEnabled = t2;
  const {
    data: profile,
    isLoading: isProfileLoading
  } = useGetProfileQuery(undefined);
  const sidebarConfig = config ?? streamerHubSidebarConfig;
  const accountType = userInfo?.accountType ?? "";
  let t3;
  if ($[3] !== accountType || $[4] !== isChallengesClipsEnabled || $[5] !== isChallengesFeatureEnabled || $[6] !== isNewsEnabled || $[7] !== sidebarConfig.navBackOffice || $[8] !== sidebarConfig.navGroups) {
    const mainNavGroups = sidebarConfig.navGroups?.map(group => ({
      ...group,
      items: group.items.filter(item => {
        if (item.url === "/news" && !isNewsEnabled) {
          return false;
        }
        if (item.url === "/challenges" && !isChallengesFeatureEnabled) {
          return false;
        }
        return isVisibleToAccount(item.roles, accountType);
      })
    })).filter(_temp) ?? [];
    let t4;
    if ($[10] !== accountType || $[11] !== isChallengesClipsEnabled || $[12] !== sidebarConfig.navBackOffice) {
      const adminItems = sidebarConfig.navBackOffice?.filter(item_0 => {
        if (!isVisibleToAccount(item_0.roles, accountType)) {
          return false;
        }
        if (item_0.url === ADMIN_ROUTES.challenges && !isChallengesClipsEnabled) {
          return false;
        }
        return true;
      }) ?? [];
      t4 = adminItems.length > 0 ? [{
        title: "ADMIN",
        items: adminItems.map(_temp2)
      }] : [];
      $[10] = accountType;
      $[11] = isChallengesClipsEnabled;
      $[12] = sidebarConfig.navBackOffice;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    const adminGroup = t4;
    t3 = [...mainNavGroups, ...adminGroup];
    $[3] = accountType;
    $[4] = isChallengesClipsEnabled;
    $[5] = isChallengesFeatureEnabled;
    $[6] = isNewsEnabled;
    $[7] = sidebarConfig.navBackOffice;
    $[8] = sidebarConfig.navGroups;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const groups = t3;
  let t4;
  if ($[14] !== groups || $[15] !== isProfileLoading || $[16] !== profile || $[17] !== sidebarConfig) {
    t4 = {
      sidebarConfig,
      groups,
      profile,
      isProfileLoading
    };
    $[14] = groups;
    $[15] = isProfileLoading;
    $[16] = profile;
    $[17] = sidebarConfig;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
}
function _temp2(item_1) {
  return {
    title: item_1.name,
    url: item_1.url,
    icon: item_1.icon
  };
}
function _temp(group_0) {
  return group_0.items.length > 0;
}